<template>
  <div class="bet-slip bet-slip-if-bet">
    <div class="bet-slip-content with-title">
      <bet-slip-title>{{ getTranslatedBetType('if_bet') }}</bet-slip-title>

      <!-- Bet Line  -->
      <div v-for="bet in getIfs()" :key="bet.id">
        <bet-alert-message
          v-if="!bet.IsSuccess"
          error
          withoutIcon
          :description="parseBetErrorMessage(betOptionsResponse)"
        />
        <div v-else>
          <div class="bet-scroll-wrapper">
            <div v-for="selection in bet.Selections" :key="selection.OutComeId">
              <bet-alert-message
                v-if="!selection.error.IsSuccess"
                :description="parseBetErrorMessage(selection.error)"
                :canClose="true"
                @onRemove="removeBetFromSlipByIndex(selection.OutComeId)"
              />
              <bet-slip-selection
                v-else
                class="bet-slip-item-wrapper"
                :selection="selection"
                :showCheckbox="false"
                :showBuyPoints="true"
                @onBuyPointChange="onRiskChange(bet)"
                @onRemove="removeBetFromSelections(selection.OutComeId)"
                @accept="onRiskChange(bet)"
              ></bet-slip-selection>
            </div>
          </div>

          <div class="bet-slip-item-wrapper mb-0" style="border: 0">
            <div class="row">
              <div class="col-6"></div>
              <div class="col-6">
                <bet-slip-risk-input
                  class="w-100"
                  :amount.sync="bet.input_risk_amount"
                  @change="onRiskChange(bet)"
                  :min="getBetMinLimit(bet)"
                  :max="getBetMaxLimit(bet)"
                  :isCustomLimitControl="true"
                  type="RISK"
                ></bet-slip-risk-input>
              </div>
              <div class="col-12">
                <div
                  class="betslip-input-error"
                  v-if="
                    bet.input_risk_amount != '0' &&
                    bet.input_risk_amount < getBetMinLimit(bet) &&
                    !minBetConditionByBet(bet)
                  "
                  v-html="betSlipMinError(getBetMinLimit(bet))"
                ></div>

                <div
                  class="betslip-input-error error-3 pt-1"
                  v-if="minBetConditionByBet(bet)"
                  v-html="minBetConditionError()"
                ></div>
              </div>
            </div>
          </div>

          <div class="bet-slip-item-wrapper" style="border: 0">
            <span class="bet-slip-bet-type-title">{{ $t('BetSlip.ChooseOption.IfBet') }}</span>
            <select class="form-control bet-slip-form-control w-100" @change="onTypeChange($event)">
              <option :selected="selectedStateBetType === 'if_win'" value="if_win">{{ $t('BetSlip.Win Only') }}</option>
              <option :selected="selectedStateBetType === 'if_win_or_tie'" value="if_win_or_tie">
                {{ $t('BetSlip.Win Or Tie') }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <total-amounts
        class="mt-1"
        :totalBets="getTotalBetsCount()"
        :totalRiskAmount="getTotalRiskAmount()"
        :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
        :totalWinAmount="getTotalWinAmount()"
        :betOptionsResponse="getIfs()[0]"
        :disable-place-bet-button="disablePlaceBetButton()"
        :potentialReturnAmountForIfBet="potentialReturnAmountForIfBet"
        :wagerType="getWagerType()"
      ></total-amounts>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import BetSlipMixin from './bet-slip-mixin';
import snq from 'snq';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';

export default {
  mixins: [BetSlipMixin],
  computed: {
    ...mapGetters('player', ['currency', 'currencySymbol']),
    ...mapState({
      betSlipBetCount: (state) => state.betSlip.betSlipBetCount,
      betOptionsResponse: (state) => state.betSlip.betOptionsResponse,
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      selectedStateBetType: (state) => state.betSlip.selectedType,
    }),
    potentialReturnAmountForIfBet() {
      const bet = this.getIfs()[0];
      const riskAmount = parseFloat(bet.input_risk_amount);
      const amount = bet.Selections.reduce((acc, cur) => {
        let calc = acc + (riskAmount * this.americanToDecimal(cur.Odd) - riskAmount);
        return calc;
      }, 0);

      return amount + riskAmount;
    },
  },
  methods: {
    ...mapActions({
      updateBetFreeWager: 'betSlip/updateBetFreeWager',
      tryGetOptions: 'betSlip/getNewBetOptions',
    }),
    ...mapMutations({
      setSelectedBetType: 'betSlip/setSelectedBetType',
      setBetOptionsResponse: 'betSlip/setBetOptionsResponse',
    }),
    getWagerType() {
      return 'if_win';
    },
    disablePlaceBetButton() {
      return this.getIfs().some((bet) => {
        return this.minBetConditionByBet(bet) || bet.Selections.filter((a) => !a.error.IsSuccess).length>0;
      });
    },
    betSlipMinError(min) {
      let text = this.$i18n.t('betslip.amountError').toString();
      text = text.replace('{currency}', this.currency);
      text = text.replace('{min}', min);
      return text;
    },
    onRiskChange(bet) {
      bet.input_win_amount = this.getTotalWinAmount();
      this.setBetOptionsResponse(bet);
      this.notifyBetSlip(bet);
    },
    onOpenSpotsChange(bet) {
      this.notifyBetSlip(bet);
    },
    notifyBetSlip(bet) {
      this.createOrUpdateBet(
        this.createBet(bet.type, '', bet.input_risk_amount, bet.input_win_amount, 0, bet.open_spots, null),
      );
    },
    getTotalRiskAmount() {
      if (this.activeFreeBet) {
        return 0;
      }
      let total = 0;
      this.getIfs().forEach((bet) => {
        const input_risk_amount = parseFloat(bet.input_risk_amount);
        total += parseFloat(
          this.$taxHelper.applyTaxToRiskInputHidden({
            input_risk_amount,
          }),
        );
      });
      if (parseFloat(total) < 0) {
        return 0;
      }
      return this.roundAmount(total);
    },
    getTotalRiskAmountWithoutTax() {
      let total = 0;
      this.getIfs().forEach((bet) => {
        const input_risk_amount = parseFloat(bet.input_risk_amount);
        total += input_risk_amount;
      });
      if (parseFloat(total) < 0) {
        return 0;
      }
      return this.roundAmount(total * this.betSlipBetCount);
    },
    getTotalWinAmount() {
      let total = 0;
      this.getIfs().forEach((bet) => {
        const input_risk_amount = parseFloat(bet.input_risk_amount);
        const appliedTax = parseFloat(
          this.$taxHelper.applyTaxToRiskInputHidden({
            input_risk_amount,
          }),
        );

        bet.Selections.forEach((line) => {
          let decimal = this.americanToDecimal(line.Odd);
          const subTotal = parseFloat(roundAmount(appliedTax)) * parseFloat(roundAmount(decimal));
          line.input_risk_amount = input_risk_amount;
          line.input_win_amount = subTotal;
          total += parseFloat(roundAmount(subTotal));
        });
      });
      if (parseFloat(total) < 0) {
        return 0;
      }
      let returnTotal = this.roundAmount(total);
      return returnTotal;
    },
    onTypeChange($event) {
      const bet = this.getIfs()[0];
      if (!bet) return;
      const selectedBetSubType = $event.target.value;
      if (selectedBetSubType === 'if_win_or_tie') {
        this.createOrUpdateBet(
          this.createBet(
            'if_win_or_tie',
            '',
            bet.input_risk_amount,
            bet.input_win_amount,
            0,
            bet.open_spots,
            'if_win_or_tie',
          ),
        );
      } else if (selectedBetSubType === 'if_win') {
        this.createOrUpdateBet(
          this.createBet('if_win', '', bet.input_risk_amount, bet.input_win_amount, 0, bet.open_spots, 0),
        );
      }
      this.setSelectedBetType({
        type: selectedBetSubType,
        name: 'BetSlip.If Bet',
      });
      this.tryGetOptions();
    },
    getTotalBetsCount() {
      return snq(() => this.getIfs()[0].Selections.length, 0);
    },
  },
  mounted() {
    this.updateBetFreeWager(0);
  },
  created() {
    // this.betOptionsResponse.input_risk_amount = null;
    // this.betOptionsResponse.input_win_amount = null;
    // this.betOptionsResponse.WagerType = 'if_win';
    // this.betOptionsResponse.Selections.forEach((f) => {
    //   f.input_risk_amount = null;
    //   f.input_win_amount = null;
    // });
    // this.setBetOptionsResponse(this.betOptionsResponse);
  },
};
</script>
